/* eslint-disable quotes */
export const columns = [
  {
    id: 'item',
    align: 'left',
    label: 'Item',
    width: '13px',
  },
  {
    id: 'description',
    label: 'Descrição',
    align: 'left',
    width: '350px',
  },
  {
    id: 'unity',
    label: 'Und',
    width: '115px',
    align: 'center',
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'quantity',
    label: 'Qtd.',
    width: '115px',
    align: 'center',
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'unity-value',
    label: 'Valor Unitário (R$)',
    width: '115px',
    align: 'center',
    format: (value) => value.toFixed(2),
  },
  {
    id: 'budged-value',
    label: 'Valor Orçado (R$)',
    width: '120px',
    align: 'center',
    format: (value) => value.toFixed(2),
  },
  {
    id: 'finished',
    label: 'Finalizado',
    width: '60px',
    align: 'center',
  },
  {
    id: 'actions',
    label: 'Ações',
    width: '60px',
    align: 'center',
  },
];
